import appConfig from '~/config/app'

export interface PricePageYearlyPromo {
  code: string
  promotionId: string
}

const PRICE_PAGE_YEARLY_PROMO_US: PricePageYearlyPromo = {
  code: 'BTSYEARLY2026',
  promotionId: appConfig.isProdEnvironment ? 'promo_1TxTszJhgnSRU9kuHaPTg9F3' : 'promo_1TxTpUJhgnSRU9ku1T0njzS1',
}

const PRICE_PAGE_YEARLY_PROMO_NO: PricePageYearlyPromo = {
  code: 'BTSYEARLY2026NORWAY',
  promotionId: appConfig.isProdEnvironment ? 'promo_1TxpqSJhgnSRU9kuKgJnCP2T' : 'promo_1Ty1SvJhgnSRU9ku76Evlf0u',
}

const PRICE_PAGE_MONTHTLY_PROMO_US: PricePageYearlyPromo = {
  code: 'BTSMONTHLY2026',
  promotionId: appConfig.isProdEnvironment ? 'promo_1TxliTJhgnSRU9kusCC0wSaJ' : 'promo_1TxhRvJhgnSRU9kur17zeXpt',
}

const PRICE_PAGE_MONTHTLY_PROMO_NO: PricePageYearlyPromo = {
  code: 'BTSMONTHLY2026NORWAY',
  promotionId: appConfig.isProdEnvironment ? 'promo_1TyWQSJhgnSRU9kuM7GI2sFi' : 'promo_1U90paJhgnSRU9kuSxIZWef3',
}

const PRICE_PAGE_YEARLY_PROMO_BY_CURRENCY: Record<string, PricePageYearlyPromo> = {
  NOK: PRICE_PAGE_YEARLY_PROMO_NO,
  USD: PRICE_PAGE_YEARLY_PROMO_US,
}

const PRICE_PAGE_MONTHLY_PROMO_BY_CURRENCY: Record<string, PricePageYearlyPromo> = {
  NOK: PRICE_PAGE_MONTHTLY_PROMO_NO,
  USD: PRICE_PAGE_MONTHTLY_PROMO_US,
}

export const getPricePageYearlyPromo = (currency?: string): PricePageYearlyPromo | undefined =>
  currency ? PRICE_PAGE_YEARLY_PROMO_BY_CURRENCY[currency.toUpperCase()] : undefined

export const getPricePageMonthlyPromo = (currency?: string): PricePageYearlyPromo | undefined =>
  currency ? PRICE_PAGE_MONTHLY_PROMO_BY_CURRENCY[currency.toUpperCase()] : undefined
